<template>
    <a-spin :spinning="loading">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form layout="inline" :autoFormCreate="(form) => {
                    this.form = form;
                }
                    ">
                    <a-row :gutter="48">
                        <a-col :md="12" :sm="24">
                            <a-form-item label="用户uid">
                                <a-input placeholder="请扫用户码" disabled v-model="formData.uid" />
                            </a-form-item>
                            <template v-if="userInfo">
                                <div style="color:red;font-size:24px">执行操作前，请务必核对用户ID是否匹配！</div>
                                <a-form-item label="用户ID">
                                    <span style="font-size:36px;font-weight: bold;">{{ userInfo.uid }}</span>
                                </a-form-item>
                                <a-form-item label="用户头像" style="height:128px">
                                    <img class="avatar" :src="userInfo.avatar" alt="avatar" width=128 height=128
                                        style="border-radius:64px;" />
                                </a-form-item>
                                <a-form-item label="用户昵称">
                                    {{ userInfo.nickname }}
                                </a-form-item>
                            </template>
                        </a-col>
                    </a-row>
                    <template v-if="userInfo">
                        <h2>可退款订单</h2>
                        <s-table ref="table" size="default" :columns="columns" :data="loadData">
                            <template slot="count_quantity" slot-scope="text,record">
                                {{ record.quantity * record.exchange_price }}
                            </template>
                            <template slot="action" slot-scope="text,record">
                                <a-popconfirm v-if="record.status == 0" title="确认退款吗？" @confirm="refund(record)">
                                    <a>退款</a>
                                </a-popconfirm>
                                <a v-else style="color:#999">退款中</a>
                            </template>
                        </s-table>
                    </template>
                    <a-button v-if="userInfo" style="margin-top:24px"
                        @click="userInfo = null; formData = { uid: '', quantity: 0 }">重新扫码</a-button>
                </a-form>
            </div>
        </a-card>
    </a-spin>
</template>
<script>
import STable from "@/components/table/";
import { queryUserInfo } from '@/api/user'
import { Modal } from 'ant-design-vue'
import { getRefundOrderByUid, postApplyRefund } from '@/api/purchase'
import HandleUserAbnormal from './HandleUserAbnormal'

export default {
    name: 'Doll',
    components: {
        STable
    },
    mixins: [HandleUserAbnormal],
    data() {
        return {
            userInfo: null,
            formData: {
                uid: "",
                quantity: 0,
            },
            key: "",
            keyTimeID: 0,
            loading: false,
            loadData: (params) => {
                if (this.formData.uid) {
                    return getRefundOrderByUid(this.formData.uid, Object.assign(params)).then(
                        (res) => res
                    );
                }
                return Promise.resolve({ data: { records: [] } })
            },
            columns: [
                {
                    title: "兑换时间",
                    dataIndex: "created",
                    key: "created",
                },
                {
                    title: "商品名",
                    dataIndex: "goods_name",
                    key: "goods_name",
                },
                {
                    title: "兑换数量",
                    dataIndex: "quantity",
                    key: "quantity",
                },
                {
                    title: "消耗积分",
                    dataIndex: "count_quantity",
                    key: "count_quantity",
                    scopedSlots: { customRender: 'count_quantity' },
                },
                {
                    title: "兑换门店",
                    dataIndex: "branch_name",
                    key: "branch_name",
                },
                {
                    title: "操作",
                    dataIndex: "action",
                    key: "action",
                    scopedSlots: { customRender: 'action' },
                }
            ],
        }
    },
    watch: {
        userInfo: {
            handler(val) {
                if (!this.userInfo) {
                    this.bindWindowScan()
                } else {
                    this.removeWindowScan()
                }
            },
            immediate: true
        }
    },
    methods: {
        refund(record) {
            console.log(record)
            postApplyRefund(record.order_no)
                .then(res => {
                    this.$message.success("申请成功");
                    this.$refs.table.refresh()
                })
        },
        handleScan(e) {
            if (this.keyTimeID) {
                clearTimeout(this.keyTimeID)
            }
            this.keyTimeID = setTimeout(() => {
                this.key = ""
            }, 50)
            this.key += e.key
            if (this.key.indexOf("Enter") > -1) {
                this.key = this.key.replace("Enter", "")
                if (/[^\d]/.test(this.key) || this.key.length < 8 || this.key == "") {
                    return
                }
                this.getUserInfo()
                this.getRefundOrderByUid()
            }
        },
        bindWindowScan() {
            window.addEventListener('keydown', this.handleScan);
        },
        removeWindowScan() {
            window.removeEventListener('keydown', this.handleScan);
        },
        getUserInfo() {
            this.loading = true
            queryUserInfo({ uid: this.key }).then(res => {
                const { uid, nickname, avatar, id, doll, is_abnormal } = res;
                if (is_abnormal) {
                    this.loading = false
                    this.showAbnormalModal()
                    return
                }
                this.userInfo = {
                    id,
                    uid,
                    nickname,
                    avatar,
                    doll,
                }
                this.formData.uid = uid
                this.formData.quantity = 0
            })
                .finally(() => {
                    this.loading = false
                })
        },
    },
    mounted() {

    },
    beforeDestroy() {
        this.removeWindowScan()
    }
}
</script>